var _linearGradient, _clipPath, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 20,
    role: "img",
    "aria-label": "bootstrap",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bootstrap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 81,
    height: 20,
    fill: "#8511fa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkJvb3RzdHJhcDwvdGl0bGU+PHBhdGggZD0iTTExLjc3IDExLjI0SDkuOTU2VjguMjAyaDIuMTUyYzEuMTcgMCAxLjgzNC41MjIgMS44MzQgMS40NjYgMCAxLjAwOC0uNzczIDEuNTcyLTIuMTc0IDEuNTcyem0uMzI0IDEuMjA2SDkuOTU3djMuMzQ4aDIuMjMxYzEuNDU5IDAgMi4yMzItLjU4NSAyLjIzMi0xLjY4NXMtLjc5NS0xLjY2My0yLjMyNi0xLjY2M3pNMjQgMTEuMzl2MS4yMThjLTEuMTI4LjEwOC0xLjgxNy45NDQtMi4yMjYgMi4yNjgtLjQwNyAxLjMxOS0uNDYzIDIuOTM3LS40MiA0LjE4Ni4wNDUgMS4zLS45NjggMi41LTIuMzM3IDIuNUg0Ljk4NWMtMS4zNyAwLTIuMzgzLTEuMi0yLjMzNy0yLjUuMDQzLTEuMjQ5LS4wMTMtMi44NjctLjQyLTQuMTg2LS40MS0xLjMyNC0xLjEtMi4xNi0yLjIyOC0yLjI2OFYxMS4zOWMxLjEyOC0uMTA4IDEuODE5LS45NDQgMi4yMjctMi4yNjguNDA4LTEuMzE5LjQ2NC0yLjkzNy40Mi00LjE4Ni0uMDQ1LTEuMy45NjgtMi41IDIuMzM4LTIuNWgxNC4wMzJjMS4zNyAwIDIuMzgyIDEuMiAyLjMzNyAyLjUtLjA0MyAxLjI0OS4wMTMgMi44NjcuNDIgNC4xODYuNDA5IDEuMzI0IDEuMDk4IDIuMTYgMi4yMjYgMi4yNjh6bS03LjkyNyAyLjgxN2MwLTEuMzU0LS45NTMtMi4zMzMtMi4zNjgtMi40ODh2LS4wNTdjMS4wNC0uMTY5IDEuODU2LTEuMTM1IDEuODU2LTIuMjEzIDAtMS41MzctMS4yMTMtMi41MzgtMy4wNjItMi41MzhoLTQuMTZ2MTAuMTcyaDQuMTgxYzIuMjE4IDAgMy41NTMtMS4wODYgMy41NTMtMi44NzZ6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 495,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 530
  }, "bootstrap"), /*#__PURE__*/React.createElement("text", {
    x: 495,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 530
  }, "bootstrap"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.492986e562b857e5421d7404c6d35753.svg";
export { ForwardRef as ReactComponent };